import { render } from "./EditTemplateModal.vue?vue&type=template&id=e3acdeb0"
import script from "./EditTemplateModal.vue?vue&type=script&lang=ts"
export * from "./EditTemplateModal.vue?vue&type=script&lang=ts"
script.render = render

export default script